import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=dce59bd4&scoped=true&"
import script from "./index2.vue?vue&type=script&lang=js&"
export * from "./index2.vue?vue&type=script&lang=js&"
import style0 from "./index2.vue?vue&type=style&index=0&id=dce59bd4&prod&scoped=true&lang=less&"
import style1 from "./index2.vue?vue&type=style&index=1&id=dce59bd4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce59bd4",
  null
  
)

export default component.exports